import React from 'react';

import {Button, Modal} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Assets from '../../../helpers/assets';
import Colors from '../../../helpers/Colors';
import {ModalStyles} from './CubbyModalStyles';

export function CubbyAssignedSuccessModal({isOpen, onClose, orderId, cubbyId}) {
    const style = ModalStyles();

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableBackdropClick
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
            <div className={style.container}>
                <IconButton className={style.closeButton} onClick={onClose}><CloseIcon/></IconButton>
                <div className={style.body}>
                    <div className={style.leftPanel}>
                        <img src={Assets.successfullyAssigned.default} alt="assignment success"/>
                    </div>
                    <div className={style.rightPanel}>
                        <div className={style.titleText}>The order is successfully assigned</div>
                        <div className={style.subText}>The order {orderId} is assigned to {cubbyId}</div>
                        <div className={style.buttonContainer}>
                            <Button type="submit"
                                    variant="outlined"
                                    fullWidth
                                    style={{color: Colors.grubtechBlue, borderColor: Colors.grubtechBlue}}
                                    onClick={onClose}
                                    className={style.button}>Done
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}